<button
  type="button"
  role="button"
  [disabled]="disabled()"
  [attr.aria-label]="buttonTitle()"
  [title]="buttonTitle()"
  [style.cursor]="disabled() ? 'auto' : 'pointer'"
>
  <img
    alt=""
    aria-hidden="true"
    [src]="icon()"
    class="responsive-width"
    [style.width]="unselectImgWidth() || imgWidth()"
  />
</button>
